import * as React from 'react';
import { ReactSVG } from 'react-svg';
import Icon from '@material-ui/core/Icon';

import UsersIcon from '../resources/icons/users_page.svg';
import SearchIcon from '../resources/icons/search_page.svg';
import UserPageIcon from '../resources/icons/user_page.svg';
import DashboardIcon from '../resources/icons/home_page.svg';
import ReportsIcon from '../resources/icons/report_page.svg';
import AllActivitiesIcon from '../resources/icons/fact_check.svg';
import GraduationIcon from '../resources/icons/graduation-hat.svg';
import CalendarIcon from '../resources/icons/calendar.svg';

import { SidebarMenuLink } from '../molecules';
import { ROUTES } from '../constants/routes';
import SidebarShell from './AppShell/SidebarShell';

export const createIcon = (src: string) => (
  <Icon>
    <ReactSVG src={src} />
  </Icon>
);

const EmployeeSidebar = () => (
  <SidebarShell>
    <SidebarMenuLink
      icon={() => createIcon(DashboardIcon)}
      to={ROUTES.DASHBOARD}
      title="Dashboard"
    />
    <SidebarMenuLink
      icon={() => createIcon(AllActivitiesIcon)}
      to={ROUTES.ALL_ACTIVITIES}
      title="All Activities"
    />
    <SidebarMenuLink
      icon={() => createIcon(ReportsIcon)}
      to={ROUTES.REPORTS}
      title="Reports"
    />
    <SidebarMenuLink
      icon={() => createIcon(UsersIcon)}
      to={ROUTES.CONTACTS}
      title="Contacts"
    />
    <SidebarMenuLink
      icon={() => createIcon(SearchIcon)}
      to={ROUTES.SEARCH}
      title="Search"
    />
    <SidebarMenuLink
      icon={() => createIcon(UserPageIcon)}
      to={ROUTES.ACCOUNT}
      title="Account"
    />
    <SidebarMenuLink
      icon={() => createIcon(GraduationIcon)}
      to={ROUTES.WIKI}
      title="Wiki"
    />
    <SidebarMenuLink
      icon={() => createIcon(CalendarIcon)}
      to={ROUTES.BULK}
      title="Bulk Inspections"
    />
  </SidebarShell>
);

export default EmployeeSidebar;
